var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"separated-price",style:({ width: `${_vm.totalWidth}rem` })},[_c('span',{staticClass:"separated-price__price"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.price))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }